var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDualUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8125 5.75C15.8125 8.92558 13.2381 11.5 10.0625 11.5C6.88686 11.5 4.3125 8.92558 4.3125 5.75C4.3125 2.57436 6.88686 0 10.0625 0C13.2381 0 15.8125 2.57436 15.8125 5.75ZM22.2812 10.0625C25.0599 10.0625 27.3125 7.80994 27.3125 5.03125C27.3125 2.25256 25.0599 0 22.2812 0C19.5026 0 17.25 2.25256 17.25 5.03125C17.25 7.80994 19.5026 10.0625 22.2812 10.0625ZM30.1875 15.8125C30.1875 18.1943 26.6478 20.125 22.2812 20.125C21.7314 20.125 21.1946 20.0944 20.6764 20.0362C21.2457 19.4054 21.5625 18.7056 21.5625 17.9688C21.5625 15.9446 19.1719 14.1996 15.7254 13.4012C17.1462 12.2541 19.5523 11.5 22.2812 11.5C26.6478 11.5 30.1875 13.4307 30.1875 15.8125ZM10.0625 23C15.6199 23 20.125 20.7474 20.125 17.9688C20.125 15.1901 15.6199 12.9375 10.0625 12.9375C4.50514 12.9375 0 15.1901 0 17.9688C0 20.7474 4.50514 23 10.0625 23Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDualUserIcon);
export default __webpack_public_path__ + "static/media/dualUserIcon.dfe971ae279fa5365270ca6b8e83cc36.svg";
export { ForwardRef as ReactComponent };